var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_vm._v(" © 2025 AIGC数字产业园 | 版权所有"),_c('br'),_vm._v("地址：浐灞生态区 陕西数字出版基地C座 ")])
}]

export { render, staticRenderFns }